import React from 'react'
import { Helmet } from 'react-helmet'
import ActiveCatalogue from '../../components/ActiveCatalogue/ActiveCatalogue'
import BrandLogoSlider from '../../components/BrandLogoSlider'
import Footer from '../../components/Footer'
import Header from '../../components/Header'
import BudgetDetails from '../../components/BudgetDetails'

function OrderDetailsPage() {
    return (
        <>
            <Helmet>
                <title>Order Details</title>
            </Helmet>
            <Header />
            <ActiveCatalogue />
            <BudgetDetails />
            <BrandLogoSlider />
            <Footer displayFooterTop={false} />
        </>
    )
}

export default OrderDetailsPage;

